import { Skeleton } from 'ui/skeleton';

export const Loadable = ({
  children,
  height,
  isLoading,
}: {
  children: React.ReactNode;
  height: number;
  isLoading: boolean;
}) => <>{isLoading ? <Skeleton height={height} /> : children}</>;
